<template>
    <div class="current-group-row">
        <span>How many: &nbsp;</span>
        <el-select
            :value="type"
            placeholder="Select"
            @change="$emit('update:type', $event)"
        >
            <el-option
                v-for="option in typeOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"
            >
            </el-option>
        </el-select>
        <span>
            &nbsp; are in a {{ hasAtLeastOneGroup ? "package" : "carton" }}?
            &nbsp;
        </span>
        <el-input-number
            :controls="false"
            :value="quantity"
            style="margin-right: 10px"
            @change="$emit('update:quantity', $event)"
        ></el-input-number>
        <el-button type="success" @click="handleClickAdd">
            Add
        </el-button>
    </div>
</template>

<script>
export default {
    props: {
        hasAtLeastOneGroup: Boolean,
        type: String,
        quantity: String | Number,
        depth: String | Number,
    },
    data: () => ({
        typeOptions: [
            {
                value: "UNIT",
                label: "Units",
            },
            {
                value: "PACKAGE",
                label: "Packages",
            },
        ],
    }),
    methods: {
        handleClickAdd() {
            this.$emit("click:add", {
                type: this.type,
                quantity: this.quantity,
                depth: this.depth,
            });
        },
    },
};
</script>

<style scoped lang="scss">
.current-group-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}
</style>
